import { Box, Button, Chip, Tooltip } from '@mui/material';
import { Icon } from '@iconify/react';
import ToolTip from '../../../ToolTip/ToolTip';
import { CreatedAt } from '../../../../utils/constants/CreatedAt';
import OGARemarks from '../../../../views/crd/myworkspace/NewAdmissionRegister/components/OGAremarks';
import CartItemEdit from '../../../../views/ogd/myworkspace/Cart/CartEdit/CartItemEdit';
import ForecastUpdate from '../../../../views/crd/myworkspace/NewAdmissionRegister/components/ForecastUpdate';
import NonCartEdit from '../../../../views/crd/myworkspace/NewAdmissionRegister/components/NonCartEdit';
import AddRetention from '../../../../views/crd/myworkspace/NewAdmissionRegister/components/AddRetention';
import DeleteCourseEnrollment from '../../../../views/crd/myworkspace/NewAdmissionRegister/components/DeleteCourseEnrollment';

export const New26AdmissionRegister = (cro, crm, finance, dispatchParams = {}, apiToCall) => [
  {
    field: 'sl_no',
    headerName: 'Sl No',
    width: 110,
    sortable: true,
  },
  {
    field: 'admn_no',
    headerName: 'Admission No',
    width: 160,
    sortable: true,
  },
  {
    field: 'student_name',
    headerName: 'Name',
    width: 200,
    sortable: true,
  },
  {
    field: 'class_name',
    headerName: 'Class',
    width: 120,
    sortable: true,
  },
  {
    field: 'student_mob_no',
    headerName: 'Mobile',
    width: 170,
    sortable: true,
  },
  {
    field: 'course_name',
    headerName: 'Course',
    width: 250,
    toolTipGetter: true,
    sortable: true,
    // renderCell: (params) => {
    //   return <ToolTip expand={params.row.course_name} content={params.row.course_name} />;
    // },
  },
  {
    field: 'course_method',
    headerName: 'Course Method',
    width: 180,
    sortable: true,
    toolTipGetter: true,
    valueGetter: (params) => {
      return params.row.course_method || 'N/A';
    },
  },

  {
    field: 'selected_option_value',
    headerName: 'Selected Option Value',
    width: 220,
    sortable: true,
    toolTipGetter: true,
    valueGetter: (params) => {
      try {
        const value = JSON.parse(params.row.selected_option_value || '[]');
        return Array.isArray(value) ? value.join(', ') : value;
      } catch {
        return params.row.selected_option_value || 'N/A';
      }
    },
  },
  {
    field: 'syllabus_name',
    headerName: 'Syllabus',
    width: 170,
    sortable: true,
  },
  {
    field: 'sro_name',
    headerName: 'OGA Name',
    width: 150,
    sortable: true,
    cellStyle: ({ row, value }) => {
      return { color: row.sro_status == 1 ? 'rgb(21 146 27)' : 'rgb(193 12 12)' };
    },
  },
  {
    field: 'sro_remarks',
    headerName: 'OGA Remarks',
    width: 150,
    toolTipGetter: ({ row, value }) => value,
    // toolTipGetter: 'custom string',
    //toolTipGetter: true,

    renderCell: (params) => {
      return <OGARemarks CROAssignID={params.row.cro_assignment_id} />;
    },
  },
  {
    field: 'total_sessions',
    headerName: 'Total Sessions',
    width: 170,
    sortable: true,
    cellStyle: ({ row, value }) => {
      return { color: '#0004ffff', fontWeight: 'bold' };
    },
  },
  {
    field: 'sessions_completed',
    headerName: 'Sessions Completed',
    width: 200,
    sortable: true,
    cellStyle: ({ row, value }) => {
      return { color: 'rgb(13 109 61)', fontWeight: 'bold' };
    },
  },
  {
    field: 'total_sales_amount',
    headerName: 'Total Sales Amount',
    width: 200,
    sortable: true,
  },
  {
    field: 'total_fee_collected',
    headerName: 'Total Fee Collected',
    width: 200,
    sortable: true,
  },
  {
    field: 'cart_item_selected_option_currency',
    headerName: 'Currency',
    width: 150,
  },
  {
    field: 'transaction_history',
    headerName: 'Transaction History',
    type: 'action',
    actionType: 'view',
    actionKey: 'transaction_history',
    width: 180,
    buttonName: 'View', // ✅ icon only
    // toolTipGetter: ({ row }) => `View ${row.student_name}`,
  },

  // fee per session
  {
    field: 'course_enrollment_id',
    headerName: 'Course Enrollment Id',
    width: 210,
    sortable: true,
  },
  {
    field: 'cro_assignment_timestamp',
    headerName: 'CRM Assigned On',
    width: 180,
    valueGetter: (params) => {
      return CreatedAt(params.row.cro_assignment_timestamp, false);
    },
    sortable: true,
  },

  {
    field: 'course_enrollment_timestamp',
    headerName: 'Course Enrollment Date',
    width: 250,
    valueGetter: (params) => {
      return CreatedAt(params.row.course_enrollment_timestamp, false);
    },
    sortable: true,
  },

  {
    field: 'first_fee_date',
    headerName: 'First Fee Paid On',
    sortable: true,
    width: 200,
  },

  {
    field: 'first_session_date',
    headerName: 'First Session Date',
    width: 200,
    sortable: true,
  },
  {
    field: 'last_session_date',
    headerName: 'Last Session Date',
    width: 200,
    sortable: true,
  },

  {
    field: 'cro_notes',
    headerName: 'CRO Notes',
    width: 200,
    toolTipGetter: true,
    sortable: true,
  },

  {
    field: 'mappingStatus',
    headerName: 'Mapping Status',
    width: 180,
    sortable: true,
    renderCell: (params) => {
      return (
        <Chip
          size="small"
          color={
            params.row.mapping_status === 2
              ? 'success'
              : params.row.mapping_status === 1
                ? 'warning'
                : params.row.mapping_status === 0
                  ? 'error'
                  : 'info'
          }
          label={
            params.row.mapping_status === 2
              ? 'Completed'
              : params.row.mapping_status === 1
                ? 'Partially Completed'
                : params.row.mapping_status === 0
                  ? 'Not Completed'
                  : ''
          }
          variant="outlined"
          icon={
            params.row.mapping_status === 2 ? (
              <Icon icon="mdi:tick" />
            ) : (
              <Icon icon="basil:cross-outline" height="20" width="20" />
            )
          }
        />
      );
    },
  },

  {
    field: 'admission_status',
    headerName: 'Admission Status',
    width: 190,
    renderCell: (params) => {
      return (
        <Chip
          size="small"
          color={
            params.row.admission_status === 1
              ? 'success'
              : 'info' && params.row.admission_status === 2
                ? 'warning'
                : 'info' && params.row.admission_status === 0
                  ? 'error'
                  : 'info'
          }
          label={
            params.row.admission_status == 1
              ? 'Active'
              : params.row.admission_status == 2
                ? 'Temporarly Inactive'
                : 'Inactive'
          }
          variant="outlined"
          icon={
            params.row.admission_status === 1 ? (
              <Icon icon="mdi:tick" />
            ) : (
              <Icon icon="basil:cross-outline" height="20" width="20" />
            )
          }
        />
      );
    },
    sortable: true,
  },

  {
    field: 'is_student_new',
    headerName: 'Student Type',
    valueGetter: (params) => {
      return params.row.is_student_new ? 'New Admission' : 'Old Admission';
    },
    width: 160,
    sortable: true,
  },
  {
    field: 'exists_in_cart',
    headerName: 'Exists in Cart',
    width: 160,
    valueGetter: (params) => {
      return params.row.exists_in_cart === 1 ? 'Yes' : 'No';
    },
    sortable: true,
  },

  {
    field: 'student_region',
    headerName: 'Student Region',
    width: 170,
    sortable: true,
  },

  ...(!cro
    ? [
        {
          field: 'croName',
          headerName: 'CRO Name',
          width: 150,
          sortable: true,
        },
      ]
    : []),

  {
    field: 'dob',
    headerName: 'Date of Birth',
    width: 170,
    sortable: true,
  },
  {
    field: 'assessment_report_count',
    headerName: 'Assessmet Report Count',
    width: 250,
    sortable: true,
  },
  {
    field: 'current_class',
    headerName: 'Current Class',
    width: 200,
    sortable: true,
  },

  {
    field: 'course_batch_name',
    headerName: 'Batch',
    width: 150,
    sortable: true,
  },

  {
    field: 'course_enrollment_age',
    headerName: 'Course Enrollment Age (No of days)',
    width: 300,
    valueGetter: (params) => {
      return `${params?.row?.course_enrollment_age} Days`;
    },
    sortable: true,
  },
  //   {
  //     field: "expected_course_completion",
  //     headerName: "Expected Course Completion(TI)",
  //     width: 230,
  //     renderCell: (params) => {
  //       const totalSessions = parseInt(params.row.total_sessions);
  //       let sessionsPerWeek = parseInt(params.row.sro_class_per_week);
  //       const enrollmentDate = new Date(params.row.course_enrollment_timestamp);

  //       if (params.row.sro_class_per_week && sessionsPerWeek !== 0 && params.row.total_sessions ) {
  //         if (sessionsPerWeek > 5) sessionsPerWeek = 5;

  //         let totalDays = (totalSessions / sessionsPerWeek) * 7;

  //         if (totalDays % 5 !== 0) {
  //           totalDays = (Math.floor(totalDays / 5) + 1) * 5;
  //         }

  //         const completionDate = new Date(enrollmentDate);
  //         completionDate.setDate(enrollmentDate.getDate() + totalDays);

  //         const formattedDate = completionDate.toLocaleDateString("en-GB"); // dd/mm/yyyy format
  //         return formattedDate;
  //       }

  //       return "N/A";
  //     },
  //   },
  {
    field: 'levels_opted',
    headerName: 'Course Level',
    width: 160,
    valueGetter: ({ value, row }) => (row?.project_name === 'Classroom' ? 'N/A' : value),
    sortable: true,
  },

  ...(!finance
    ? [
        {
          field: 'expected_sessions',
          headerName: 'Expected Sessions',
          width: 200,
          sortable: true,
        },
      ]
    : []),

  ...(crm
    ? [
        {
          field: 'expected_completion_date',
          headerName: 'Expected Course Completion',
          width: 250,
          valueGetter: ({ value }) => value ?? 'Calendar Not Set',
          sortable: true,
        },
      ]
    : []),

  {
    field: 'course_inactive_date',
    headerName: 'Course Inactive Date',
    width: 200,
    sortable: true,
  },
  // {
  //     field: "Link",
  //     headerName: "Classroom  Materials(link)",
  //     width: 150,
  // },
  // {
  //     field: "academiccALENDAER",
  //     headerName: "Admission Calendar Available",
  //     width: 150,
  // },

  {
    field: 'admission_fee_status',
    headerName: 'Admission Fee',
    width: 200,
    renderCell: (params) => {
      return (
        <Chip
          size="small"
          color={params.row.admission_fee_status === 1 ? 'success' : 'warning'}
          label={params.row.admission_fee_status == 1 ? 'Paid' : 'Not Paid'}
          variant="outlined"
          icon={
            params.row.admission_fee_status === 1 ? (
              <Icon icon="mdi:tick" />
            ) : (
              <Icon icon="basil:cross-outline" height="20" width="20" />
            )
          }
        />
      );
    },
    sortable: true,
  },

  {
    field: 'preference_status',
    headerName: 'Preference Status',
    width: 200,
    sortable: true,
    renderCell: (params) => {
      return (
        <Chip
          size="small"
          color={params.row.preference_status ? 'success' : 'warning'}
          label={params.row.preference_status ? 'Yes' : 'No'}
          variant="outlined"
          icon={
            params.row.preference_status ? (
              <Icon icon="mdi:tick" />
            ) : (
              <Icon icon="basil:cross-outline" height="20" width="20" />
            )
          }
        />
      );
    },
  },
  {
    field: 'fee_term_informed_by_name',
    headerName: 'Fee term informed by',
    width: 220,
    sortable: true,
    valueGetter: (params) => {
      return params.row.fee_term_informed_by_name === null ? 'N/A' : params.row.fee_term_informed_by_name;
    },
  },
  {
    field: 'fee_term_informed_timestamp',
    headerName: 'Fee term informed on',
    width: 230,
    sortable: true,
    valueGetter: (params) => {
      return params.row.fee_term_informed_timestamp === null ? 'N/A' : params.row.fee_term_informed_timestamp;
    },
  },
  {
    field: 'cart_item_selected_option',
    headerName: 'Forecast Method',
    width: 200,
    sortable: true,
    valueGetter: (params) => {
      return params.row.cart_item_selected_option === null ? 'Manual' : 'System';
    },
  },

  ...(crm
    ? [
        {
          field: 'non_cart_edit',
          headerName: 'Non Cart Edit',
          width: 150,
          renderCell: (params) => {
            return <NonCartEdit rowData={params.row} />;
          },
        },
      ]
    : []),
  ...(crm || cro
    ? [
        {
          field: 'retention',
          headerName: 'Upsell',
          width: 150,
          renderCell: (params) => (
            <AddRetention
              row={params.row}
              dispatchParams={{ ...dispatchParams, hardRefresh: true }}
              apiCall={apiToCall}
            />
          ),
        },
        {
          field: 'deleteCourse',
          headerName: 'Delete Course',
          width: 150,
          renderCell: (params) => (
            <DeleteCourseEnrollment
              row={params.row}
              dispatchParams={{ ...dispatchParams, hardRefresh: true }}
              apiCall={apiToCall}
            />
          ),
        },
      ]
    : []),
  ...(finance
    ? [
        {
          field: 'forecast_changed_by',
          headerName: 'Forecast Changed By',
          width: 200,
          valueGetter: (params) => {
            return params.row.forecast_changed_by === null ? 'N/A' : params.row.forecast_changed_by;
          },
          sortable: true,
        },
      ]
    : []),
  ...(finance
    ? [
        {
          field: 'forecast_modified_at',
          headerName: 'Changed On',
          width: 200,
          valueGetter: (params) => {
            return params.row.forecast_modified_at === null ? 'N/A' : params.row.forecast_modified_at;
          },
          sortable: true,
        },
      ]
    : []),
  ...(crm
    ? [
        {
          field: 'forecast_update',
          headerName: 'Forecast Break',
          width: 200,
          renderCell: (params) => (
            <ForecastUpdate
              dispatchParams={{ ...dispatchParams, hardRefresh: true }}
              row={params.row}
              apiCall={apiToCall}
            />
          ),
        },
      ]
    : []),
  ...(crm || finance
    ? [
        {
          field: 'cart_edit',
          headerName: 'Cart Edit',
          width: 150,
          renderCell: (params) => <CartItemEdit row={params.row} />,
        },
      ]
    : []),
  ...(crm || cro
    ? [
        {
          field: 'Course_Activation',
          headerName: 'Course Activation',
          type: 'action',
          actionType: 'edit',
          actionKey: 'Course Enrollment Status',
          buttonName: 'Edit Status',
          width: 170,
          isDisabled: ({ row, value }) => row?.admission_status === 1,
        },
      ]
    : []),

  // {
  //   field: "add",
  //   headerName: "Add",
  //   type: "action",
  //   actionType: "add",
  //   actionKey: "ADD_STUDENT",
  //   buttonName: "Add",
  //   isDisabled: (row) => row.status !== "Active",
  //   toolTipGetter: ({row}) => `Add ${row.student_name}`,
  // },

  // {
  //   field: "edit",
  //   headerName: "Edit",
  //   type: "action",
  //   actionType: "edit",
  //   actionKey: "EDIT_STUDENT",
  //   hover: "Edit Student",
  //   buttonProps: {
  //     style: {
  //       minWidth: 80,
  //     },
  //   },
  // },

  // {
  //   field: "delete",
  //   headerName: "Delete",
  //   type: "action",
  //   actionType: "delete",
  //   actionKey: "DELETE_STUDENT",
  //   buttonName: "",
  //   isDisabled: (row) => row.status === "Deleted",
  //   toolTipGetter: (row) =>
  //     row.status === "Deleted" ? "Already Deleted" : `Delete ${row.student_name}`,
  // },

  // {
  //   field: "nav",
  //   headerName: "Go",
  //   type: "action",
  //   actionType: "navigate",
  //   actionKey: "GO_PROFILE",
  //   hover: "Navigate to profile",
  //   icon: "mdi:open-in-new",
  // },
];
